import * as Util from "../Utils/Util";
import DomFactory from "../Utils/DomFactory";
import Events from "../Utils/Events";
import Hider from "../Utils/Hider";

export default class PricingTable {
  private readonly element: HTMLElement;
  private readonly code: string;

  public constructor(element: HTMLElement) {
    this.element = element;
    this.code = Util.getData(element, "strengthCode");
    Events.on("pricing-table-strength-changed", (code: string) => Hider.match(this.element, code === this.code));
  }

  public static Factory: DomFactory<PricingTable> = (e) => new PricingTable(e);
}
